/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILdsTermsAndConditionsViewProps } from './lds-terms-and-conditions';
// import { lDSPublisherPolicyAsync } from '../../actions/DataActionExtension.g';

const ContentBlockView: React.FC<ILdsTermsAndConditionsViewProps> = props => {
    const [currentPolicyData, setCurrentPolicyData] = React.useState<any>();

    const getPolicy = async () => {
        if (props.data.policyInfo) {
            setCurrentPolicyData(props.data.policyInfo.result);
        }

        return;
    };

    React.useEffect(() => {
        void getPolicy();
    }, [props.data]);

    return (
        <div style={{ width: '100%', backgroundColor: '#FFF' }}>
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <div
                    // style={{ maxWidth: '800px' }}
                    dangerouslySetInnerHTML={{
                        __html: currentPolicyData && currentPolicyData.HTMLContent ? currentPolicyData.HTMLContent : ''
                    }}
                />
            </div>
        </div>
    );
};

export default ContentBlockView;
